module.exports = __webpack_public_path__ + "static/media/facebook.becc1a48.svg";